import CTAButtons from "./CTAButtons";

const CLEANER_IMG = "https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/c596f9f0e_Screenshot2026-07-01at135415.png";

export default function ManchesterContact({ config }) {
  const cityName = config?.cityName || "Manchester";
  return (
    <section style={{ backgroundColor: "#FFFFFF", padding: "clamp(60px,7vw,96px) clamp(20px,5vw,80px)" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", borderRadius: 16, overflow: "hidden", background: "#112215" }} className="mc-card-grid">
          {/* Image */}
          <div style={{ minHeight: 420, background: "#E8E4D5" }}>
            <img src={CLEANER_IMG} alt="Local cleaning team" loading="lazy" style={{ width: "100%", height: "100%", objectFit: "cover", display: "block", minHeight: 420 }} />
          </div>

          {/* Content with header inside */}
          <div style={{ padding: "44px 44px", display: "flex", flexDirection: "column" }}>
            <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "0.1em", textTransform: "uppercase", color: "#CCF5AC", marginBottom: 12, marginTop: 0 }}>On the ground</p>
            <h2 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 700, fontSize: "clamp(24px,3vw,34px)", letterSpacing: "-0.02em", lineHeight: 1.2, color: "#F4F1E7", margin: "0 0 18px" }}>
              A local team who can actually be at your door
            </h2>
            <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 15, color: "rgba(244,241,231,0.82)", lineHeight: 1.7, margin: "0 0 16px" }}>
              One dedicated point of contact who knows your flat, your boiler, your lockbox code and your neighbourhood{config ? ` in ${cityName}` : ""}. When a guest locks themselves out at 9pm or the boiler stops on a Saturday, our local contractors can be there the same day.
            </p>
            <p style={{ fontFamily: "'Inter', sans-serif", fontSize: 15, color: "rgba(244,241,231,0.82)", lineHeight: 1.7, margin: "0 0 28px" }}>
              Your property is inspected after every stay by cleaners and maintenance teams we've worked with for years{config ? ` across ${cityName}` : ""}.
            </p>
            <div style={{ marginTop: "auto" }}>
              <CTAButtons align="left" dark />
            </div>
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) { .mc-card-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </section>
  );
}